import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';

// Components
import Header from './components/Header';
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import ThankYou from './pages/ThankYou';
import Footer from './components/Footer';
import DeviceWidthIndicator from './components/DeviceWidthIndicator';

// Service Pages
import {
  ReportingDashboardService,
  DataEngineeringService,
  DataScienceService,
  SystemIntegrationService,
  DataLakehouseService,
  DataModelingService,
  CloudPlatformsService,
  DatabaseService
} from './pages/ServicePages';

// Global styles
const GlobalContainer = styled.div`
  font-family: 'Arial', sans-serif;
  color: #002033;
`;

function App() {
  return (
    <Router>
      <GlobalContainer>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/thankyou" element={<ThankYou />} />
          
          {/* Service Detail Routes */}
          <Route path="/services/reporting-dashboarding" element={<ReportingDashboardService />} />
          <Route path="/services/data-engineering" element={<DataEngineeringService />} />
          <Route path="/services/data-science" element={<DataScienceService />} />
          <Route path="/services/system-integration" element={<SystemIntegrationService />} />
          <Route path="/services/data-lakehouse" element={<DataLakehouseService />} />
          <Route path="/services/data-modeling" element={<DataModelingService />} />
          <Route path="/services/cloud-platforms" element={<CloudPlatformsService />} />
          <Route path="/services/database-development" element={<DatabaseService />} />
        </Routes>
        <Footer />
        <DeviceWidthIndicator />
      </GlobalContainer>
    </Router>
  );
}

export default App;
